import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Box, Button, IconButton, Tooltip, Typography } from '@material-ui/core';
import LogoutIcon from '@mui/icons-material/Logout';
import _ from 'lodash';
import { getBook, getStoryAsLazy, getStoryChapters,getStory } from '../../../redux/actions/buddyBooks';
import { getSettings } from '../../../redux/actions/settings';
import { getSavedSession, getStudent } from '../../../redux/actions/students';
import objectiveedLogo from "../../../assets/images/objectiveedLogo.png"
import { Bars, Rings, SpinningCircles, Puff, Oval, Hearts, Circles, TailSpin, BallTriangle, Audio, ThreeDots } from 'react-loading-icons'
import { connect } from 'react-redux';
import './styles.scss';
import InputDeviceSetting from '../Setting/InputDeviceSetting';
import { logout } from '../../../redux/actions/auth';

let gotBook = false;
let dispatchSavedSession = false;
let dispatchStory = false;

let currentIndex;
const PreparingBookPage = ({
    book,
    story,
    getStoryFail,
    savedSessionResponse,
    dispatch
}) => {
    const [loading, setLoading] = useState(true);
    const [errMsg, setErrMsg] = useState("");
    const [storyId, setStoryId] = useState('');

    let history = useHistory();

    useEffect(() => {
        if (!(_.isEmpty(story))) {
            setLoading(false);
        } else {
            if (!gotBook) {
                console.log("inside if gotBook");
                dispatch(getBook());
                dispatch(getSettings());
                dispatch(getStudent());
                gotBook = true;
                dispatchStory = true;
                dispatchSavedSession = true;
            }
        }
    }, [])


    useEffect(() => {
        if (book.data) {
            setErrMsg('');
            console.log("book.data")
            localStorage.setItem("book_id", book.data?.id);
            let bs = localStorage.getItem('book_story');
            let bookStory = bs && JSON.parse(bs);
            if (bookStory && bookStory.storyDto.id === book.data?.id) {
                if (dispatchSavedSession) {
                    dispatch(getSavedSession(book.data?.id));
                    dispatchSavedSession = false;
                }
                let id = bookStory.storyDto.id;
                gotBook = false;
                history.push(`/story/${id}`);
            } else {
                let keysToRemove = ["current_section", "book_story"];

                for (let key of keysToRemove) {
                    localStorage.removeItem(key);
                }

                if (dispatchSavedSession) {
                    setStoryId(book.data?.id);
                    dispatch(getSavedSession(book.data?.id));
                    dispatchSavedSession = false;
                }

                if (!(_.isEmpty(savedSessionResponse.data)) && dispatchStory) {
                    let data = savedSessionResponse.data;
                    let currentGroup = parseInt(data.currentSection) === -1 ? 0 : parseInt(data.currentSection);
                    let sectionStart = Math.sign(currentGroup - 100) === -1 ? 0 : currentGroup - 100;
                    currentIndex = parseInt(JSON.parse(data.indexes)[0]);
                    console.log('sectionStart login', sectionStart);
                    dispatch(getStoryAsLazy(book.data?.id, sectionStart, 200));
                    dispatch(getStoryChapters(book.data?.id));
                    dispatchStory = false;
                }

                if (!(_.isEmpty(story))) {                   
                    setLoading(false);               
                    if(currentIndex){
                        let idx1 = story.storySegmentDto;
                        if(currentIndex < idx1[0].groupNumber || currentIndex > idx1[idx1.length - 1].groupNumber)
                        dispatch(getStory(book.data?.id));
                    }
                }
            }
        }

        if (book.isError) {
            gotBook = false;
            setLoading(false);
            setErrMsg('Please ask your teacher to assign and activate your book.');
        }
    }, [book, savedSessionResponse, story, getStoryFail,])

    const handleSubmit = () => {
        if (!(_.isEmpty(story))) {
            gotBook = false;
            history.push(`/story/${storyId}`)
        }
    }
    
    const handleLogout = () => {
        gotBook = false;
        document.body.style.background = "#ddf0ff";

        //clearing local storage keys
        localStorage.setItem(`review_done`, "false");
        let keysToRemove = ["logged_user", "reporting_time", "book_id", "current_section"];

        for (let key of keysToRemove) {
            localStorage.removeItem(key);
        }

        dispatch(logout());
        window.getStoryCalled = false;
        window.getSavedSessionCalled = false;
        window.getSettingsCalled = false;
        setTimeout(() => {
            history.push("/");
        }, 500);
    }

    return (
        <Box className='book_page_container'>
            <div className='logo'>
                <img src={objectiveedLogo} alt="objectiveedLogo" width={300} height={150} />
            </div>

            <Box className='logout_box'>
                <Tooltip title="Logout" arrow>
                    <IconButton
                        variant="contained"
                        color="secondary"
                    >
                        <LogoutIcon className='logout_icon' />
                    </IconButton>
                </Tooltip>
                <Typography component='div' variant='subtitle1' onClick={() => { handleLogout(); }}>Logout</Typography>
            </Box>
            {
                loading
                    ? <Box>
                        <BallTriangle
                            fill='#F39463'
                            stroke="#98aaaa"
                        />
                        <Typography component='div' variant='subtitle1' className='header'>
                            Preparing your book
                        </Typography>
                    </Box>

                    : errMsg
                        ? <Box>
                            <Typography component='div' variant='subtitle1' className='error'>
                                {errMsg}
                            </Typography>
                        </Box>
                        : <Box my={3}>
                            <Button
                                type="submit"
                                id='submit'
                                variant="contained"
                                small='true'
                                className="btn"
                                onClick={handleSubmit}
                            >
                                <Typography component='div' htmlFor="username" className='label'>Start reading</Typography>
                            </Button>
                        </Box>
            }

            <Box className='instruction_container'>
                <label className='label'>Instructions: </label>
                <Typography component='div' variant='subtitle1' className='instructions'>
                    Your computer reading partner will read a passage from the book to you. After they finish
                    reading, it will give you a passage to read. Read the passage out loud, and press enter when
                    you have finished reading.
                </Typography>
                <br />
                <Typography component='div' variant='subtitle1' className='instructions'>
                    <b>End Turn: </b>Press ENTER when you have finished reading during your turn
                </Typography>
                <Typography component='div' variant='subtitle1' className='instructions'>
                    <b>Pause: </b>Press SPACEBAR to pause
                </Typography>
            </Box>
            <Box sx={{display: 'flex', justifyContent: 'center'}}>
                <InputDeviceSetting noModal={true} />
            </Box>

        </Box>
    )
}

const mapState = ({ platform: { analysis: { book, getStoryFail, savedSessionResponse }, story } }) => {
    return {
        book,
        story,
        getStoryFail,
        savedSessionResponse
    }
};

export default connect(mapState)(PreparingBookPage);